import React, { useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Dialog,
  Fab,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
  Toolbar,
  Typography,
  debounce,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Add, Close, Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { LoadingBox } from "../../../../../components/utils";
import CostCentersTable from "./components/CostCentersTable";
import { CostCentersDialog } from "./components/CostCentersDialog";
import { getCostCenters, getCostCenter } from "../../../../services/pwsApi";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "primary",
    backgroundColor: "rgba(0, 0, 0, 0.25) !important",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CostCenters() {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const companyCode = searchParams.get("company_code");
  const costCenterId = searchParams.get("cost_center_id");

  const tablePageIndex = Number(searchParams.get("page") ?? 1);
  const tablePageSize = Number(searchParams.get("page_size") ?? 50);

  const costCentersQuery = useQuery(
    ["cost-centers", companyCode, tablePageIndex, tablePageSize, searchQuery],
    () =>
      getCostCenters(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        searchQuery,
        {
          page: tablePageIndex,
          perPage: tablePageSize,
        },
      ),
    {
      enabled: !!companyCode,
    },
  );

  const costCenterQuery = useQuery(
    ["cost-center", costCenterId],
    () =>
      getCostCenter(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        costCenterId,
      ),
    {
      enabled: !!costCenterId,
      onSuccess: () => setDialogOpen(true),
    },
  );

  let costCenter = costCenterQuery.data?.data?.data;
  costCenter = costCenter
    ? {
        costCenterId: costCenter.CTT_CUSTO ?? null,
        costCenterCode: costCenter.CTT_CUSTO,
        costCenterName: costCenter.CTT_DESC01,
        classOption: costCenter.CTT_CLASSE,
        costCenterType: costCenter.CTT_TPLOT,
      }
    : null;

  const handleCloseDialog = () => {
    searchParams.delete("screen");
    setSearchParams(searchParams);
  };

  const handleCloseUserDialog = () => {
    searchParams.delete("cost_center_id");
    setSearchParams(searchParams);

    setDialogOpen(false);
  };

  const handleCreateCostCenter = () => {
    setDialogOpen(true);
  };

  const searchDelayed = debounce(query => {
    setSearchQuery(query);
  }, 1000);

  const costCenters = costCentersQuery?.data?.data?.data ?? [];
  const rows = costCentersQuery?.data?.data?.meta?.total ?? 0;

  return (
    <Dialog
      fullScreen
      open
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      {dialogOpen && (
        <CostCentersDialog onClose={handleCloseUserDialog} data={costCenter} />
      )}
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Centros de Custo
          </Typography>
        </Toolbar>
      </AppBar>
      <Backdrop
        className={classes.backdrop}
        open={costCentersQuery?.isLoading ?? true}
      >
        <LoadingBox />
      </Backdrop>
      <Box sx={{ height: "calc(100% - 94px)", padding: "15px" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TextField
            style={{ width: "400px" }}
            label="Pesquisar"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={event => {
              searchDelayed(event.target.value);
            }}
          />
        </Box>
        <CostCentersTable data={costCenters} rows={rows} />
      </Box>
      {/* <Fab
        color="primary"
        aria-label="add"
        className={classes.fab}
        onClick={handleCreateCostCenter}
      >
        <Add />
      </Fab> */}
    </Dialog>
  );
}
